import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'minuteSecondTimeFormat',
  standalone: true
})
export class MinuteSecondTimeFormatPipe implements PipeTransform {

  transform(value: number): string {
    // const minutes: number = Math.floor(value / 60000);
    // const seconds: number = Math.floor((value % 60000) / 1000);
    const minutes: number = Math.floor(value / 1000 / 60); // Convert milliseconds to minutes
    const seconds: number = Math.floor((value / 1000) % 60); // Convert milliseconds to seconds
    return `${this.pad(minutes)}:${this.pad(seconds)}`;
  }

  pad(value: number): string {
    return value < 10 ? '0' + value : value.toString();
  }

}
